import { AnyAction, createAsyncThunk } from "@reduxjs/toolkit";

import MarketService from "api/market/MarketService";
import { NotificationType, Notifications } from "types";
import { getNotification } from "helpers";
import { throttle } from "utils";

import { setConfig } from "./slice";
import { addNotification } from "../notification/slice";

export const getConfig = createAsyncThunk(
  'web3Config/getConfig',
  throttle(async (_: any, { dispatch, extra }: any) => {
    try {
      const marketService = extra.marketService as MarketService;
      const { config } = await marketService.getConfig();

      dispatch(setConfig(config));
    } catch (error) {
      dispatch(addNotification({ type: NotificationType.Canceled, msg: getNotification(Notifications.TryAgain, _t) }));
    }
  }, 1000)
) as unknown as () => AnyAction;